import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import ImageSize from "../library/ImageSize";
import Model from "./Model";
export class ImageExtension extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'id',
      content: null
    });
    _defineProperty(this, "ImageExtensionsId", {
      fieldName: 'id',
      content: null
    });
    _defineProperty(this, "width", {
      fieldName: 'width',
      content: null
    });
    _defineProperty(this, "height", {
      fieldName: 'height',
      content: null
    });
    _defineProperty(this, "ImageExtensionsExtension", {
      fieldName: 'extension',
      content: null
    });
    _defineProperty(this, "ImageExtensionsPath", {
      fieldName: 'path',
      content: null
    });
    _defineProperty(this, "sizes", {
      fieldName: 'sizes',
      model: ImageSize,
      content: []
    });
  }
  getPath() {
    return this.ImageExtensionsPath.content;
  }
  getWidth() {
    return this.width.content;
  }
  getHeight() {
    return this.height.content;
  }
  getSizes() {
    return this.sizes.content;
  }
  getName() {
    return this.ImageExtensionsExtension.content;
  }
}
export default ImageExtension;